export default class Range<T> {
    public items: T[] = [];

    constructor(obj?: Partial<Range<T>>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
